<template>
  <div id='newfirm' class=''>
    <el-form label-position="right" ref="form" :rules='rules' label-width="100px" :model='form' style='width:60%;margin-top:20px;'>
      
      <el-form-item :label="$t('app_type')" prop='tel'>
        <el-select style='width:100%;' v-model="type"  :placeholder="$t('app_select')" @change='selectChange'>
          <el-option
            v-for="item in types"
            :key="item.vl"
            :label="item.label"
            :value="item.vl">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if='type === 1' :label="$t('app_deviceNo')" prop='dvNo'>
        <el-input v-model="form.dvNo" placeholder=''></el-input>
      </el-form-item>

      <span v-else>
        <el-form-item :label="$t('app_distributor')" prop='distributor'>
          <el-select style='width:100%;' v-model="form.distributor" clearable :placeholder="$t('app_select')" @change='selectMc'>
            <el-option
              v-for="item in mechs"
              :key="item.mechanismid"
              :label="item.mechanismname"
              :value="item.mechanismid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('app_deviceNum')" prop='tel'>
          <label>{{devices}}</label>
        </el-form-item>
      </span>
    

      <el-form-item :label="$t('app_ofCheck')" prop=''>
        <el-radio class="radio" v-model="radio" label="1">{{$t('app_open')}}</el-radio>
        <el-radio class="radio" v-model="radio" label="0">{{$t('app_close')}}</el-radio>
      </el-form-item>

    
    </el-form>
    <div>
      <el-button  type='primary' style='width:15%;margin-left:25%;' @click="save()">{{$t('app_save')}}</el-button>
    </div>
    <div style='background:#D3DCE6;width:100%;height:1px;margin-top:50px;'></div>


    <div style='border-top:0px solid #8492A6;text-align:center;'>
      <p style='text-align:left;margin-top:20px;margin-bottom:20px;'>{{$t('app_operateHis')}} </p>
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%">
        <el-table-column
          header-align='center'
          align='center'
          prop="operationTime"
          :label="$t('app_time')"
          width="175">
        </el-table-column>


        <el-table-column
          header-align='center'
          align='center'
          prop="merchantName"
          :label="$t('app_distributor')"
          width="">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="opearationType"
          :label="$t('app_operateType')"
          width="">
          <template slot-scope='scope'>
            <label v-show="scope.row.opearationType === '0'">{{$t('app_closeCerCheck')}}</label>
            <label v-show="scope.row.opearationType === '1'">{{$t('app_openCerCheck')}}</label>
            <label v-show="scope.row.opearationType === '2'">{{$t('app_cnAndActive')}}</label>
            <label v-show="scope.row.opearationType === '3'">{{$t('app_downCer')}}</label>
          </template>
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="successQuantity"
          :label="$t('app_success')"
          width="">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop='failQuantity'
          :label="$t('app_fail')"
          width="">
         
        </el-table-column>

        <el-table-column
          header-align='center'
          align=center
          prop="cancelNums"
          :label="$t('app_operate')"
          width="">
          <template slot-scope='scope'>
            <!-- <el-button @click='hisOperate(1, scope.row)' v-show="scope.row.opearationType === '1' && scope.row.operateAgain === '1'"  type=text>{{$t('app_reOpen')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_reOpen')" placement="top">
              <el-button type='text' @click='hisOperate(1, scope.row)' v-show="scope.row.opearationType === '1' && scope.row.operateAgain === '1'"><i class="fa fa-arrow-up" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button @click='hisOperate(0, scope.row)'  v-show="scope.row.opearationType === '0' && scope.row.operateAgain === '1'" type=text >{{$t('app_reClose')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_reClose')" placement="top">
              <el-button type='text' @click='hisOperate(0, scope.row)'  v-show="scope.row.opearationType === '0' && scope.row.operateAgain === '1'"><i class="fa fa-window-close" style=""></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>


      <div class="block" style='float:right;margin-top:20px;'>
        <el-pagination
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>


  </div>
</template>

<style>
</style>

<script>
  export default{
    data () {
      var phoneCheck = (rule, value, callback) => {
        if (0) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
      return {
        tableData: [],
        index: 1,
        row: this.$gRow,
        devices: 0,
        token: localStorage['user'],
        type: 2,
        types: [
          {label: '渠道商', vl: 2},
          {label: '设备', vl: 1}
        ],
        radio: '1',
        mech: '',
        mechs: [],
        fatherList: [],
        form: {
          distributor: '',
          ofCheck: '',
          dvNo: ''
        },
        rules: {
          distributor: [
            { required: true, message: this.$t('app_selectChannel'), trigger: 'blur' }
          ],
          dvNo: [
            { required: true, message: this.$t('app_input'), trigger: 'blur' }
          ]
        },
        index: 1
      }
    },
    methods: {
      hisOperate (is, row) {
        var otype = is ? '0' : '1'
        console.log(row)
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isOperate'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.$cerRightHisOperate(row.id,'', row.merchantId, otype, row.pushtype, (res) => {
            this.loading = 0
            // console.log('bo', res)
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getHis()
            } else {
              this.$message.error(res.message)
            }
            
          }, () => {
            this.loading = 0
            this.$message.error(this.$t('app_rqsError'))
          })
        }, '')
   
      },
      pageSelect (index) {
        // this.$setWPage('appMarketPage', index)
        this.index = index
        this.getHis()
      },
      pageSized (val) {
        this.$gRow = val
        this.getHis()
      },
      selectMc (vl) {
        this.getDevices(vl)
      },
      getDevices (mId) {
        // console.log(mId)
        this.$getChannelDevices(mId, (res) => {
          console.log('dvs', res)
          if (res.status === 200) {
            this.devices = res.data.nums
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
        }) 
      },
      btn () {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isActive'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var ids = ''
          this.multipleSelection.forEach((vl) => {
            ids += vl.packagename + ','
          })
          ids = ids.substring(0, ids.length - 1)
          // console.log(ids)
          if (!ids) {
            this.$message(this.$t('app_chooseOneMust'))
            return
          }
          this.loading = 1
          if (this.$appUrlTag === 0) {
            this.$appDistributeOnOff(this.mechanismId, ids, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getHis()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          } else {
            this.$appDistributeOnOff1(this.mechanismId, ids, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getHis()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          }
          
        }, '')
      },
      save () {
        this.$refs['form'].validate((valid) => {
          if (valid) {

            this.loading = 1
            var type = (this.radio === '1') ? '1' : '0'
            var tNo = (this.type === 1) ? this.form.dvNo : this.form.distributor
            this.$cmOperate('YQCTL', type, tNo, this.type, (res) => {
              this.loading = 0
              if (res.status === 200) {

                this.$message(res.message)
              } else {
                this.$message.error(res.message)
              }
            }, () => {
              // error
              this.loading = 0
              this.$message.error(this.$t('app_rqsError'))
            })

          } else {
            return false
          }
        })
      },
      getHis () {
        this.loading = 1
        var flag = '0,1'
        this.$cerRightHistory(this.index, this.$gRow, this.token, flag, (res) => {
          this.loading = 0
          if (res.status === 200) {
            console.log('his',res)
            this.tableData = res.data
            this.total = res.total
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      }
    },
    mounted () {
      
      this.getHis()

      this.$getChannelList(999, 1, '', '', '', (res) => {
        if (res.status === 200) {
          console.log(res)
          this.mechs = res.data
        } else {
          this.$message.error(res.message)
        }
      }, () => {
        this.$message.error(this.$t('app_rqsError'))
      })
    }
  }
</script>



// WEBPACK FOOTER //
// checkOnoff.vue?6ff08758